import React from "react";
import './Gamesecon.css'
const Gamesecond = () => {
  return (
    <>
       <div className="point-main-game">
        <div className="point-game-div">
          <div className="game-result-main-div2">
            <div className="game-result-flex2">
              <div className="game-result-div2"></div>
              <div className="game-result-div-img2"></div>
              <div className="game-result-div2"></div>
              <div className="game-result-div2"></div>
              <div className="game-result-div2"></div>
              <div className="game-result-div-img2"></div>
              <div className="game-result-div2"></div>
              <div className="game-result-div2"></div>
              <div className="game-result-div2"></div>
              <div className="game-result-div-img2"></div>
              <div className="game-result-div2"></div>
              <div className="game-result-div2"></div>
              <div className="game-result-div2"></div>
              <div className="game-result-div-img2"></div>
              <div className="game-result-div2"></div>
              <div className="game-result-div2"></div>
            </div>
          </div>
          <div className="point-div-flex">
            <div>
              <span className="gray-p-game">Point </span>
            </div>
            <div>
              {" "}
              <spna className="black-p-game">₹20</spna>
            </div>
            <div>
              {" "}
              <span className="gray-p-game">Delivery: ₹19</span>
            </div>
          </div>
          <div>
            <div>
              <spna className="gray-p-game">Pass</spna>
            </div>
            <div>
              <spna className="black-p-game">2</spna>
            </div>
          </div>
          <div className="bonus-div">
            <div>
              <p className="gray-p-game" dir="rtl">
                Bonus
              </p>
            </div>
            <div>
              <p className="red-p-game" dir="rtl">
                ₹0+
              </p>
            </div>
            <div>
              <spna className="gray-p-game">Free: ₹1</spna>
            </div>
          </div>
        </div>
        <div className="date-game-div">
          <div>
            <spna className="gray-p-game">08/08/2022</spna>
          </div>
          <div>
            <a className="link-game-blue" href="/">
              complaint
            </a>{" "}
          </div>
        </div>
      </div>
    </>
  );
};

export default Gamesecond;
